import styled from 'styled-components';
import colors from 'constants/colors';
import DropDownArrowIcon from 'assets/icons/dropdownArrow.svg';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 0;
  position: relative;
  cursor: pointer;
  
  .label {
    font-size: 13px;
    font-weight: 600;
    color: ${colors.silver};
    letter-spacing: 1px;
    white-space: nowrap;
    margin-bottom: 5px;
  }

  .select {
    min-width: 71px;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    color: ${(props) => (props.disabled? colors.silver: colors.white)};
    background-color: ${(props) => (props.disabled? colors.dimGrey: props.mainPage ? 'transparent' : colors.black2)};
    height: 40px;
    background-image: ${({disabled})=>disabled? 'none': `url(${DropDownArrowIcon})`};
    background-position: 95% 50%;
    background-repeat: no-repeat;
    border: 1px solid ${(props) => (props.disabled? colors.silver: props.error ? colors.red : colors.darkGrey)};
    border-radius: 0;
    padding: 9px;
    overflow: hidden;
    text-overflow: ellipsis;

    ${({disabled})=>disabled? `
        background-image: none;
      `:null};
    
    ${(props) => props.mainPage ? 'background-size: 10px 10px': null};

    .value {
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 0.5px;
    }

    .dropDownPlaceholder {
      font-size: 14px;
      letter-spacing: 0.5px;
      font-weight: 300;
      font-style: italic;
      letter-spacing: 1px;
      color: ${colors.white};
    }

    .selectedResult {
      background: ${colors.charcoal};
      padding: 0 9px;
      margin-right: 4px;
      border-radius: 10px;
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 0.5px;
      color: ${colors.white};
      white-space: nowrap;
    }
  }

  .warning {
    width: 100%;
    height: 20px;
    line-height: 20px;
    color: ${colors.red};
    font-size: 14px;
    font-weight: 600;
    white-space: normal;
    word-wrap: break-word; 
    word-break: break-all;
    overflow: visible;
    text-align: left;
    margin-top: 5px;
  }

  .options {
    max-height: 290px;
    position: absolute;
    overflow-y: scroll;
    top: ${(props) => (props.title ? '60px' : '40px')};
    letter-spacing: 1px;
    width: 100%;
    border: solid ${colors.darkGrey};
    border-width: 0 1px 1px 1px; 
    z-index: 1500;

    ::-webkit-scrollbar { 
      width: 0 !important; 
    }

    ::-moz-scrollbar {
      width: 0 !important; 
    }
  }

  ${(props) => props.additionalstyle};
`;

export const StyledItem = styled.div`
  width: 100%;
  height: 36px;
  line-height: 35px;
  font-size: 14px;
  font-weight: ${({isSelected}) => isSelected? 700: 400};;
  padding-left: 10px;
  color: ${colors.white};
  background-color: ${({isSelected}) => isSelected? colors.black2: colors.black4};
  overflow: hidden;

  .highlight {
    color: ${colors.white};
  }

  :hover {
    color: ${colors.lightBlue};
    border-left: 5px solid ${colors.lightBlue};
    background-color: ${colors.darkBlue};
    padding-left: 5px;
    font-weight: bold;

    .highlight {
      color: ${colors.lightBlue};
    }
  }
`;